import React from 'react';

const MessageModal = ({ 
  show, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  variant = 'info',
  showConfirm = false,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false
}) => {
  if (!show) return null;

  // 1. Logic to determine the HEX color based on variant
  const getThemeColor = () => {
    switch (variant) {
      case 'success':
        return '#046525'; // Your custom Green
      case 'error':
      case 'danger':
        return '#dc3545'; // Standard Red (you can change this to a hex too)
      case 'warning':
        return '#ffc107'; // Standard Yellow
      case 'info':
      default:
        return '#0084d9'; // Your custom Blue
    }
  };

  const activeColor = getThemeColor();

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      onClick={onClose}
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
    >
      <div
        className="modal-dialog"
        role="document"
        onClick={(e) => e.stopPropagation()} 
      >
        <div className="modal-content">
          {/* 2. Changed: Using style={{ backgroundColor: activeColor }} instead of class */}
          <div className="modal-header text-white" style={{ backgroundColor: activeColor }}>
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              aria-label="Close"
              onClick={onClose}
              disabled={loading}
            />
          </div>
          <div className="modal-body">
            <p className="mb-0">{message}</p>
          </div>
          <div className="modal-footer">
            {showConfirm ? (
              <>
                <button 
                  type="button" 
                  className="btn btn-secondary rounded-pill" 
                  onClick={onClose}
                  disabled={loading}
                >
                  {cancelText}
                </button>
                {/* 3. Changed: Applying activeColor to the confirm button */}
                <button 
                  type="button" 
                  className="btn text-white rounded-pill" 
                  style={{ backgroundColor: activeColor, border: 'none' }}
                  onClick={onConfirm}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : (
                    confirmText
                  )}
                </button>
              </>
            ) : (
              // 4. Changed: Applying activeColor to the OK button
              <button 
                type="button" 
                className="btn text-white rounded-pill" 
                style={{ backgroundColor: activeColor, border: 'none' }}
                onClick={onClose}
                disabled={loading}
              >
                OK
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;